import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormControl } from '@angular/forms';

@Component({
    selector: 'tvcore-switch',
    templateUrl: './switch.component.html',
    styleUrls: ['./switch.component.scss'],
    standalone: false
})
export class SwitchComponent implements OnInit {
	@Input()
	name: string;
	@Input()
	showErrors: boolean;
	@Input()
	YES: string;
	@Input()
	NO: string;

	control: FormControl | null;

	constructor(private controlContainer: ControlContainer) {}

	ngOnInit() {
		this.control = this.controlContainer.control?.get(this.name) as FormControl;
	}

	hasError(name: string): boolean {
		return !!this.control?.hasError(name);
	}

	hasErrors(): boolean {
		if (this.showErrors) {
			return !!this.control?.errors;
		}

		return false;
	}

	isValue(value: boolean) {
		return this.control?.value === value;
	}

	setValue(value: boolean) {
		this.control?.setValue(value);
	}
}
